<div class="image-background flex justify-center flex-col">
    <div class="text-section flex flex-col items-center">
        <div class="text-title flex flex-col items-center">
            <span class="title font-black">Rooted In Passion, </span>
            <span class="title font-black">Growing Through Purpose</span>
        </div>
        <span class="sub-title font-bold">The people behind CDS</span>
        <span class="text font-normal">We’re a team dedicated to turning ideas into impactful solutions. Built on vision and fueled by passion, we craft experiences that connect. Every pixel, every word, every detail - made with purpose.</span>
    </div>
    <div class="logo-section">
        <om-marquee [animationDuration]="'5s'" [marqueeGap]="'8rem'" [pauseOnHover]="true" styleClass="custom-marquee" [scrollable]="true">
            <ng-template>
                <img class="item" src="../../../assets/images/heartland.svg" />
            </ng-template>
            <ng-template>
                <img class="item" src="../../../assets/images/xenial.svg" />
            </ng-template>
            <ng-template>
                <img class="item" src="../../../assets/images/sentral.svg" />
                </ng-template>
                <ng-template>
                    <img class="item" src="../../../assets/images/ezidebit.svg" />
                </ng-template>
                <ng-template>
                    <img class="item" src="../../../assets/images/away.svg" />
            </ng-template>
        </om-marquee>
    </div>
</div>
